import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { namespaceInstallableContent } from '@next-adapter/installable-runtime/namespace-installable-content.js'
import { renderCoreStorageProviderRenderer } from '@next-adapter/templates/renderers/integration-runtime/render-core-storage-provider.js'
import { getActiveStorageProvider } from './get-active-storage-provider.js'

export function renderCoreStorageProvider(config: ResolvedBetterstartConfig): string {
  const activeProvider = getActiveStorageProvider(config)
  const providerImport = activeProvider
    ? `import { ${activeProvider.exportName} } from '${activeProvider.importPath}'\n`
    : ''
  const providerBranch = activeProvider
    ? renderCoreStorageProviderRenderer({
        kind: 'renderCoreStorageProviderContentTemplate',
        props: {
          activeProviderExportName: String(activeProvider.exportName)
        }
      })
    : ''

  return namespaceInstallableContent(
    config,
    renderCoreStorageProviderRenderer({
      kind: 'renderCoreStorageProviderGeneratedFunctionTemplate',
      props: {
        providerImport: String(providerImport),
        providerBranch: String(providerBranch)
      }
    })
  )
}
